// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__1JpQP","container":"styles_container__B969d"};